const a = (e) => {
  const o = ["sales_pro", "ultimate", "presence"], t = e == null ? void 0 : e.toLowerCase();
  return o.find(
    (r) => t == null ? void 0 : t.startsWith(r)
  ) || e;
};
export {
  a as getSubscriptionPlanRoot
};
